module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"languages":["en","id"],"defaultLanguage":"en","siteUrl":"https://forestmonitoring.hutanharapan.id/v2","trailingSlash":"always","generateDefaultLanguagePage":false,"fallbackLanguage":"en","redirect":false,"i18nextOptions":{"fallbackLng":"en","supportedLngs":["en","id"],"defaultNS":"common","interpolation":{"escapeValue":false}}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
